// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__jWidd","title__cointainer":"styles_title__cointainer__QulJC","head__title":"styles_head__title__a4Isn"};